import Vue from "vue";
import Vuex from "vuex";
import Axios from "axios";
import router from "../router";
import auth from "./auth";
import categories from "./categories";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    message: "",
    loading: false,
    snackbar: {},
    locale: "pt-pt"
  },
  getters: {
    getMessage: state => {
      return state.message;
    },
    getLoading: state => {
      return state.loading;
    },
    getSnackbar: state => state.snackbar,
    getLocale: state => {
      return state.locale;
    }
  },
  mutations: {
    setMessage(state, message) {
      state.message = message;
    },
    setLoading(state, payload) {
      state.loading = payload.loading;
    },
    sendMessage(state, payload) {
      state.snackbar = { ...payload, active: true };
    },
    closeMessage(state) {
      state.snackbar.active = false;
    },
    setLocale(state, payload) {
      state.locale = payload;
    }
  },
  modules: {
    auth,
    categories
  }
});
